import * as React from 'react';
import SearchBar from './SearchBar';
import { Taxonomy } from '../../types/index'
import { Tab, Tabs, Box, Divider, Checkbox, FormControlLabel, Button, Radio } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Stores } from '../../services/store'

type RepeatTaxonomy = {
  parentTaxonomy: Taxonomy,
  childTaxonomies: RepeatTaxonomy[] | null
}

type TaxonomyTree = {
  name: string
  taxonomies: RepeatTaxonomy[]
}

const selectItems = [
  {
    id: "all",
    name: "全割引商品"
  },
  {
    id: "under25",
    name: "25%以下割引商品"
  },
  {
    id: "50",
    name: "25～50%割引商品"
  },
  {
    id: "75",
    name: "50～75%割引商品"
  },
  {
    id: "over76",
    name: "75以上の割引商品"
  },
]

export default function SearchQueryTabs(props: {
  taxonomies: Readonly<Taxonomy[]>
}) {

  const [tabValue, setTabValue] = React.useState(0)
  const [taxonomyTrees, setTaxonomyTrees] = React.useState([] as TaxonomyTree[])


  React.useEffect(() => {
    // 'category', 'post_tag', 'situation', 'other', 'series', 'nav_menu'のうち'category', 'post_tag', 'nav_menu'は除外
    const taxonomyNameList = Array.from(new Set(props.taxonomies.map(taxonomy => taxonomy.taxonomy)))
      .filter(taxonomy => !['nav_menu'].includes(taxonomy))
    const getTaxonomyTree = (name: string, targetId: number): {
      parentTaxonomy: Taxonomy,
      childTaxonomies: RepeatTaxonomy[]
    }[] => {
      const taxonomies = props.taxonomies.filter(taxonomy => taxonomy.parent === targetId && taxonomy.taxonomy === name)
      if (taxonomies.length < 1) return null
      return taxonomies.map(taxonomy => {
        const data = getTaxonomyTree(name, taxonomy.term_taxonomy_id)
        return {
          parentTaxonomy: taxonomy,
          childTaxonomies: data
        }
      })
    }
    const taxonomyTree = taxonomyNameList.map(taxonomyName => (
      {
        name: taxonomyName,
        taxonomies: getTaxonomyTree(taxonomyName, 0)
      }
    ))
    setTaxonomyTrees([
      {
        name: "keyword",
        taxonomies: null
      },
      ...taxonomyTree,
      {
        name: "discounts",
        taxonomies: null
      }

    ])
  }, [props.taxonomies])

  const handleChange = (event: React.SyntheticEvent, value: number) => setTabValue(value)

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  const state = Stores.useContainer()

  const convertTabNameToJp = (name: string) => {
    const tabRelationName = {
      "keyword": "キーワード",
      "post_tag": "タグ",
      "category": "カテゴリー",
      "situation": "シチュエーション",
      "other": "その他",
      "series": "シリーズ",
      "discounts": "割引"
    }
    return tabRelationName[name] ?? name
  }

  return (
    <React.Fragment>
      <Box sx={{
        borderBottom: 1,
        borderColor: 'divider',
        background: "linear-gradient(#c10339 0%,#c15171 100%)",
      }}>
        <Tabs value={tabValue}
          onChange={handleChange}
          variant="scrollable"
          aria-label="basic tabs example"
          scrollButtons
          allowScrollButtonsMobile
        >
          {taxonomyTrees.map((taxonomyTree, index) =>
            <Tab
              style={{
                color: "#fafafa",
              }}
              label={convertTabNameToJp(taxonomyTree.name)} {...a11yProps(index)} key={index} />
          )}
        </Tabs>
      </Box>
      {taxonomyTrees.map((taxonomyTree, index) => (
        <Box
          sx={{
            maxHeight: 300,
            overflow: 'auto',
            backgroundColor: "#fef4f4"
          }}
          key={`TabPanel${index}`}
        >
          <TabPanel value={tabValue} index={index} taxonomyTree={taxonomyTree} />
        </Box>
      )
      )}
      <Divider />
      <Box sx={{
        p: 3,
        borderBottom: 1,
        borderColor: 'divider',
        backgroundColor: "#fef4f4"
      }} >
        <Box >
          <Button style={{ marginBottom: 5 }} onClick={() => state.selectAllRemove()} variant="contained" color='error' startIcon={<DeleteIcon />}>
            全て削除
          </Button>
        </Box>
        {state.keyword && (
          <UserSelectBlock
            value={state.keyword}
            onClick={() => state.setKeyword("")}
          />
        )}
        {state.selectDiscountId && (
          <UserSelectBlock
            value={selectItems.find(selectItem => selectItem.id === state.selectDiscountId).name}
            onClick={() => state.setSelectDiscountId("")}
          />
        )}
        {state.selectTermTaxonomyIds.map((selectTermTaxonomyId, index) => (
          <UserSelectBlock
            key={`selectTermTaxonomyId${index}`}
            value={state.taxonomies.find(taxonomy => taxonomy.term_taxonomy_id == selectTermTaxonomyId).term.name}
            onClick={() => state.changeSelectTermTaxonomyIds(Number(selectTermTaxonomyId))}
          />
        )
        )}
      </Box>
    </React.Fragment>
  );
}

const UserSelectBlock = (props: {
  value: string
  onClick: () => void
}) => {
  return (
    <Box component="span" sx={{ ml: 3 }}>
      <Button style={{ marginBottom: 5 }} onClick={() => props.onClick()} variant="contained" color='error' startIcon={<DeleteIcon />}>
        {props.value}
      </Button>
    </Box>
  )
}


const TabPanel = (props: {
  taxonomyTree: TaxonomyTree
  value: number
  index: number
}) => {
  const { value, index, taxonomyTree } = props
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <>
          {taxonomyTree.name === "keyword" ? (
            <KeywordBlock />
          ) : taxonomyTree.name === "discounts" ? (
            <DiscountsRadioBoxBlock />
          ) : taxonomyTree.name === "category" ? (
            <IndeterminateCheckBoxBlock repeatTaxonomies={taxonomyTree.taxonomies} />
          ) : (
            <SingleCheckBoxBlock repeatTaxonomies={taxonomyTree.taxonomies} />
          )
          }
        </>
      )}
    </div>
  );
}

const KeywordBlock = () => {
  const state = Stores.useContainer()
  return (
    <SearchBar
      clickEvent={state.setKeyword}
    />
  )
}

/**割引 */
const DiscountsRadioBoxBlock = () => {
  const state = Stores.useContainer()
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    state.setSelectDiscountId(event.target.value as "" | "all" | "under25" | "50" | "75" | "over76")
  }

  return (
    <Box sx={{ p: 3 }}>
      {selectItems.map((discount, index) => (
        <FormControlLabel
          style={{
            marginLeft: 15,
            marginRight: 15,
            marginTop: 0,
            marginBottom: 0
          }}
          key={`SingleCheckBoxBlock${index}`}
          label={discount.name}
          labelPlacement="start"
          control={
            <Radio
              name="radio-buttons"
              color="success"
              value={discount.id}
              checked={state.selectDiscountId === discount.id}
              onChange={handleChange}
            />
          }
        />
      ))
      }
    </Box>
  )
}

/**階層型のチェックボックス。2階層まで対応 */
const IndeterminateCheckBoxBlock = (props: {
  repeatTaxonomies: RepeatTaxonomy[]
}) => {
  const { repeatTaxonomies } = props
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => state.changeSelectTermTaxonomyIds(Number(event.target.value))

  const state = Stores.useContainer()
  return (
    <Box sx={{ p: 3 }}>
      {repeatTaxonomies.map((repeatTaxonomy, index) => (
        <>
          <FormControlLabel
            style={{
              marginLeft: 15,
              marginRight: 15,
              marginTop: 0,
              marginBottom: 0
            }}
            key={`repeatTaxonomy+${index}`}
            label={checboxLabel(repeatTaxonomy.parentTaxonomy.term.name, repeatTaxonomy.parentTaxonomy.count)}
            labelPlacement="start"
            control={
              <Checkbox
                color="success"
                value={repeatTaxonomy.parentTaxonomy.term_taxonomy_id}
                checked={state.selectTermTaxonomyIds.includes(repeatTaxonomy.parentTaxonomy.term_taxonomy_id)}
                onChange={handleChange}
              />
            }
          />
          <Box sx={{ ml: 3 }}>
            {repeatTaxonomy.childTaxonomies?.map((childrenTaxonomy, index) => (
              <FormControlLabel
                style={{
                  marginLeft: 15,
                  marginRight: 15,
                  marginTop: 0,
                  marginBottom: 0
                }}
                key={`childrenTaxonomy${index}`}
                label={checboxLabel(childrenTaxonomy.parentTaxonomy.term.name, childrenTaxonomy.parentTaxonomy.count)}
                labelPlacement="start"
                control={
                  <Checkbox
                    color="success"
                    value={childrenTaxonomy.parentTaxonomy.term_taxonomy_id}
                    checked={state.selectTermTaxonomyIds.includes(childrenTaxonomy.parentTaxonomy.term_taxonomy_id)}
                    onChange={handleChange}
                  />
                } />
            ))}
          </Box>
          <Divider />
        </>
      ))
      }
    </Box>
  )
}

/**階層構造がない */
const SingleCheckBoxBlock = (props: {
  repeatTaxonomies: RepeatTaxonomy[]
}) => {
  const { repeatTaxonomies } = props

  const state = Stores.useContainer()
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => state.changeSelectTermTaxonomyIds(Number(event.target.value))

  return (
    <Box sx={{ p: 3 }}>
      {repeatTaxonomies.map((repeatTaxonomy, index) => (
        <FormControlLabel
          style={{
            marginLeft: 15,
            marginRight: 15,
            marginTop: 0,
            marginBottom: 0
          }}
          key={`SingleCheckBoxBlock${index}`}
          label={checboxLabel(repeatTaxonomy.parentTaxonomy.term.name, repeatTaxonomy.parentTaxonomy.count)}
          labelPlacement="start"
          control={
            <Checkbox
              color="success"
              value={repeatTaxonomy.parentTaxonomy.term_taxonomy_id}
              checked={state.selectTermTaxonomyIds.includes(repeatTaxonomy.parentTaxonomy.term_taxonomy_id)}
              onChange={handleChange}
            />
          }
        />
      ))
      }
    </Box>
  )
}

const checboxLabel = (text: string, count: number) => text + ":" + count + "件"